import { render } from "./pop-up.vue?vue&type=template&id=7e67ae91&scoped=true"
import script from "./pop-up.vue?vue&type=script&lang=js"
export * from "./pop-up.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7e67ae91"

export default script